import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useIntl } from 'react-intl'
import useInputs from '../../../utils/hooks/useInputs.js'
import CenterService from '../../../services/centers/center.service.js'
import useHandlerBasicActions from '../../../utils/hooks/useHandlerBasicActions.js'
import useModal from '../../../utils/hooks/useModal.js'
import './centersMain.scss'
import { urlBack } from './utils/center.utils.ts'
import CenterTechnicsForm from './form/CenterTechnicsForm.tsx'
import CenterSection from './common/CenterSection.tsx'
import AppButton from '../../../component/common/AppButton.tsx'
import AppToolbar from '../../../component/layout/AppToolbar.tsx'

const CenterTechnics = () => {
  const { formatMessage: msg } = useIntl()
  const { isShowingViewer, toggleViewer } = useModal()

  const { id } = useParams()

  const [currentCenter, setCurrentCenter] = useState()
  const { inputs, onChangeInputs, updateInputs } = useInputs()

  const navigate = useNavigate()

  useEffect(() => {
    getCenterData()
    getCenterTechnics()
  }, [])

  useEffect(() => {
    dataFacade.reload()
  }, [inputs])
  // useEffect(() => {
  //     if (!isShowing) getCenterDataContracts()
  // }, [isShowing])

  const getCenterData = async () => {
    const response = await CenterService.getById(id)
    if (response) {
      setCurrentCenter(response.resp)
    }
  }

  const getCenterTechnics = async () => {
    const response = await CenterService.technics.getById(id)
    // console.log('getCenterTechnics', response)
    if (response) {
      updateInputs(response?.resp)
    }
  }

  const handleSave = async () => {
    const data = {
      ...inputs,
    }
    const response = await CenterService?.technics?.update({ id, body: data })
    if (response) {
      navigate(urlBack(inputs?.centerType))
    }
  }

  const dataFacade = useHandlerBasicActions({
    sortFieldInitial: 'comercialDataId',
    // getAll: () => { return { resp: inputs?.renewalDate } },
    getAll: () => {
      return { resp: inputs?.files }
    },
  })

  const data = (
    <CenterTechnicsForm
      centerId={id}
      handleSave={handleSave}
      inputs={inputs}
      onChangeInputs={onChangeInputs}
      updateInputs={updateInputs}
    />
  )

  return (
    <CenterSection
      mainContainer="scrollarea"
      toolbar={
        <AppToolbar
          rightSection={[
            <AppButton
              preset="back"
              onClick={() => navigate(urlBack(inputs?.centerType))}
            />,
            <AppButton preset="save" onClick={handleSave} />,
          ]}
        />
      }
    >
      {data}
    </CenterSection>
  )
}

export default CenterTechnics
